<div class="bg-white shadow-sm hover:border-slate-300 hover:shadow-md transition-all">
  <div class="p-4">
    <div class="flex justify-between items-center mb-4">
      <h5 class="text-slate-200 text-lg font-semibold flex items-center">
        <mat-icon class="align-top mr-2">local_shipping</mat-icon>
        Carrier
      </h5>

      <!-- Region Selector Moved to the Right -->
      <div class="flex space-x-4">
        <sa-median-selector
          hintText="Applies to 'Dispatch Time' and 'Completion Time' columns only."
          [medians]="medians"
          [default]="median"
          (newItemEvent)="onMedianChange($event)"
        ></sa-median-selector>
        <sa-timeframe-selector
          [timeframes]="[30, 60, 90, 120]"
          [default]="timeframe"
          (newItemEvent)="onTimeframeChange($event)"
        ></sa-timeframe-selector>
      </div>
    </div>

    <div class="relative">
      <!-- Loading Indicator -->
      <div
        *ngIf="loading"
        class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10"
      >
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <!-- Data Table -->
      <table mat-table [dataSource]="dataSource" class="w-full">
        <!-- Carrier Name -->
        <ng-container matColumnDef="carrierName">
          <th mat-header-cell *matHeaderCellDef>Carrier Name</th>
          <td mat-cell *matCellDef="let element">{{ element.carrierName }}</td>
        </ng-container>

        <!-- Average Dispatch Time -->
        <ng-container matColumnDef="averageDispatchTime">
          <th mat-header-cell *matHeaderCellDef>Avg. Dispatch Time</th>
          <td mat-cell *matCellDef="let element">{{ element.averageDispatchTime | minutesToHuman }}</td>
        </ng-container>

        <!-- Number of Loads Missed or Posted -->
        <ng-container matColumnDef="totalLoadsUpForGrabsOrMissed">
          <th mat-header-cell *matHeaderCellDef>Total Loads Up For Grabs Or Missed</th>
          <td mat-cell *matCellDef="let element">{{ element.totalLoadsUpForGrabsOrMissed }}</td>
        </ng-container>

        <!-- Average Time to Complete Loads -->
        <ng-container matColumnDef="averageCompletionTime">
          <th mat-header-cell *matHeaderCellDef>Avg. Completion Time</th>
          <td mat-cell *matCellDef="let element">{{ element.averageCompletionTime | minutesToHuman }}</td>
        </ng-container>

        <!-- Unique Driver Count -->
        <ng-container matColumnDef="uniqueDrivers">
          <th mat-header-cell *matHeaderCellDef>Unique Drivers</th>
          <td mat-cell *matCellDef="let element">{{ element.uniqueDrivers | number }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
